import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import Helmet from 'react-helmet';
import axios from 'axios';

import translate from  '../../../utils/translate';
import baseUrl from  '../../../utils/baseUrl';

import connect from '../../../utils/connect';

import BlockContent from '../../account/block/content';

import AccountJuryFOTX from './fotx';

import JuryNav from './juryNav';
import JurySticky from './jurySticky';

import Splitter from '../block/splitter';
import Spinner from '../../svg/spinner';

import { AccountJuryOther, AccountJuryMediaTitle } from './other';
import { caseFilterResponsive } from './juryHelper';

//import translate from '../../../utils/translate';
//import * as actions from '../../../actions/account';

//import css from './fotd.scss';
const API_URL = baseUrl + '/api/account/jury/foty';

class AccountJuryFOTY extends Component {

	constructor(props) {
		super();

		this.mounted = true;

		this.state = {
			waiting: true,
			cases: [],
		};
	}

	componentWillReceiveProps(nextProps) {}

	componentWillMount() {
		axios.get(API_URL)
		.then((res) => {
			if (this.mounted && res.data && res.data.cases) {
				this.setState({
					...this.state,
					...res.data,
					waiting: false,
				});
			}
		})
		.catch((res) => {});
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	render() {
		if (this.state.waiting) {
			return this.renderWaiting();
		}

		let cases = caseFilterResponsive(this.state.cases, this.props.browser);
		let { currentVotes, isVotingOpen, nextDate, linkAbout } = this.state;

		return (
			<div className=''>
				<div className='account-block-content'>
					<div className='span14 account-block-content__aside account-jury__head'>
						{this.state.cases.length} projects up for voting
					</div>

					<div className='cf'></div>

					<JurySticky browser={this.props.browser} className='account-jury__sticky'>
						<div className='span5 span5-tablet span14-mobile account-jury__col1 account-jury__subhead account-jury__subhead--first'>
							<JuryNav users={this.props.users} />
						</div>

						<div className='hide-tablet hide-mobile account-jury__col2'></div>

						<div className='span9-tablet span14-mobile account-jury__col3 hide-mobile account-jury__subhead'></div>
						<div className='cf'></div>
					</JurySticky>
				</div>

				<div className='account-block-content account-jury__infoblock'>
					<div className='span5 span5-tablet hide-mobile account-jury__col1'>
						<div className='account-jury__col1__about'>About</div>
					</div>
					<div className='span9-tablet span14-mobile account-jury__col2 account-jury__scorecard__intro'>
						<p dangerouslySetInnerHTML={{ __html: translate('account/jury/foty') }}></p>
					</div>

					<div className='span0 span5-tablet hide-mobile account-jury__col1'></div>
					<div className='span9-tablet span14-mobile account-jury__col3'>
						{(!!linkAbout) && (
							<div>
								<p className='account-jury__linklist-head'>Read more</p>
								<ol className='account-jury__linklist'>
									<li className='account-jury__linklist__item'><Link to={linkAbout.url}>{linkAbout.text}</Link></li>
								</ol>
							</div>
						)}
					</div>

					<div className='cf'></div>
				</div>

				<AccountJuryFOTX {...this.props} api={API_URL} cases={cases} currentVotes={currentVotes} isVotingOpen={isVotingOpen} nextDate={nextDate}></AccountJuryFOTX>

				{(this.props.browser.window.width < 1200) && (
					<AccountJuryOther browser={this.props.browser} dispatch={this.props.dispatch} allCases={this.state.cases} cases={cases} />
				)}

			</div>
		);
	}

	renderWaiting() {
		return (
			<div key='spinner' style={{ textAlign: 'center', width: '100%', marginTop: '50px' }}>
				<Spinner size='60' />
			</div>
		);
	}
}

export default connect(AccountJuryFOTY);



/** WEBPACK FOOTER **
 ** ./frontend/components/account/jury/foty.js
 **/